import React from 'react';
import { Search, X } from 'lucide-react';

const MOTS_CLES = ['Électricité', 'Éclairage', 'Plomberie', 'Chauffage', 'Climatisation', 'Ventilation', 'Menuiserie', 'Charpente',
  'Couverture', 'Étanchéité', 'Isolation', 'Plâtrerie', 'Peinture', 'Carrelage', 'Revêtement', 'Façade', 'Maçonnerie', 'Béton',
  'Démolition', 'Terrassement', 'Fondation', 'Voirie', 'Réseaux', 'Assainissement', 'Piscine', 'Serrurerie', 'Vitrerie',
  'Photovoltaïque', 'Ascenseur', 'Télécommunication', 'Diagnostic'];

export const normaliser = (s) => (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

const texte = (a) => normaliser(`${a.code} ${a.nom} ${a.referentiel || ''}`);
const racine = (mot) => normaliser(mot).slice(0, Math.max(5, normaliser(mot).length - 2));

export const filtrerActivites = (activites, recherche, motsActifs, selectedIds, seulementSelection) => {
  const q = normaliser(recherche).trim();
  return activites.filter((a) => {
    const t = texte(a);
    if (seulementSelection && !selectedIds.includes(a.id)) return false;
    if (q && !q.split(/\s+/).every((m) => t.includes(m))) return false;
    if (motsActifs.length && !motsActifs.some((m) => t.includes(racine(m)))) return false;
    return true;
  });
};

export const motsDisponibles = (activites) => MOTS_CLES.filter((m) => activites.some((a) => texte(a).includes(racine(m))));

const Pastille = ({ actif, onClick, children, testid }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className={`rounded-full border px-2.5 py-0.5 text-xs font-medium transition-colors ${actif ? 'bg-indigo-700 border-indigo-700 text-white' : 'bg-white border-slate-200 text-slate-700 hover:border-indigo-300 hover:text-indigo-800'}`}>
    {children}
  </button>
);

export default function ActivitesFiltre({ categorie, mots, recherche, setRecherche, motsActifs, setMotsActifs, seulementSelection, setSeulementSelection, total, visibles }) {
  const basculer = (m) => setMotsActifs(motsActifs.includes(m) ? motsActifs.filter((x) => x !== m) : [...motsActifs, m]);
  const actif = recherche || motsActifs.length || seulementSelection;
  return (
    <div className="space-y-2" data-testid={`filtre-activites-${categorie}`}>
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
        <input value={recherche} onChange={(e) => setRecherche(e.target.value)} placeholder="Rechercher par nom, code ou mot-clé…"
          className="w-full rounded-lg border border-slate-200 bg-white py-2 pl-9 pr-8 text-sm focus:border-indigo-400 focus:outline-none"
          data-testid={`filtre-recherche-${categorie}`} />
        {recherche && <button type="button" onClick={() => setRecherche('')} className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400" aria-label="Effacer"><X className="h-4 w-4" /></button>}
      </div>
      <div className="flex flex-wrap gap-1.5">
        <Pastille actif={seulementSelection} onClick={() => setSeulementSelection(!seulementSelection)} testid={`filtre-selection-${categorie}`}>Sélectionnées</Pastille>
        {mots.map((m) => <Pastille key={m} actif={motsActifs.includes(m)} onClick={() => basculer(m)} testid={`filtre-mot-${categorie}-${normaliser(m)}`}>{m}</Pastille>)}
      </div>
      {actif && (
        <div className="flex items-center justify-between text-xs text-slate-500">
          <span data-testid={`filtre-compteur-${categorie}`}>{visibles} activité{visibles > 1 ? 's' : ''} sur {total}</span>
          <button type="button" className="text-indigo-700 hover:underline" onClick={() => { setRecherche(''); setMotsActifs([]); setSeulementSelection(false); }} data-testid={`filtre-reinitialiser-${categorie}`}>Effacer les filtres</button>
        </div>
      )}
    </div>
  );
}
